import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async productos(producto) {
    const response = await api.post(API_URL + "productos", producto);
    if (response.data) return response.data;
  },

  async guardaProducto(producto) {
    const response = await api.post(API_URL + "guardaProducto", producto);
    if (response.data) return response.data;
  },

  async consultaProducto(uuid) {
    try {
      const response = await api.post(API_URL + "consultaProducto", uuid);
      return response.data;
    } catch (e) {
      const status = e?.response?.status;
      const msg = e?.response?.data?.mensaje || e?.response?.data?.message;
      if (status === 410) return { res: "NOK", mensaje: msg || "Servicio expirado" };
      if (status === 404) return { res: "NOK", mensaje: msg || "Producto no disponible" };
      return { res: "NOK", mensaje: msg || "Error consultando el producto" };
    }
  },

  async borraProducto(userId) {
    const response = await api.post(API_URL + "borraProducto", userId);
    if (response.data) return response.data;
  },

  validarDescuento(data) {
    return api.post(API_URL + "validarDescuento", data);
  },

  async exportarProductos() {
    return await api.post(API_URL + "productos/export", {}, { responseType: "blob" });
  },

  async obtenerRebajaProducto(data) {
    const response = await api.post(API_URL + "obtenerRebajaProducto", data);
    if (response.data) return response.data;
  },

  async listaSimple(tipsterId) {
    const response = await api.post(API_URL + "productos/simple", { tipster_id: tipsterId || 0 });
    if (response.data) return response.data;
    return [];
  },
};
